import React from 'react';
import { MathRenderer } from '../utils/mathRenderer';

const MathExpression = ({ 
  children, 
  inline = true, 
  className = '', 
  style = {} 
}) => {
  // Clean the LaTeX expression by removing dollar signs if present
  const cleanLatex = (text) => {
    if (typeof text !== 'string') return text;
    
    // Remove LaTeX delimiters if present
    let cleaned = text
      .replace(/^\$|\$$/g, '') // Remove leading/trailing dollar signs
      .replace(/\\\(|\\\)/g, '') // Remove \( \) delimiters
      .replace(/\\\[|\\\]/g, ''); // Remove \[ \] delimiters
    
    return cleaned;
  };

  const cleanedContent = cleanLatex(children);

  // Use the simple HTML renderer instead of MathJax to eliminate flickering
  return (
    <MathRenderer 
      className={className}
      style={style}
    >
      {cleanedContent}
    </MathRenderer>
  );
};

export default MathExpression; 